module.exports = __webpack_public_path__ + "img/2.8f6eb5eb.jpg";